module.exports = __webpack_public_path__ + "img/glc_logo.e0ad0098.svg";